import type React from 'react';
import type { BasicContentBlockB } from '@course-authoring/shared-types';
import { BasicContentBlockRenderer } from './BasicContentBlockRenderer';

export interface BasicContentBlockBRendererProps {
  block: BasicContentBlockB;
  className?: string;
}
export function BasicContentBlockBRenderer({
  block,
  className,
}: BasicContentBlockBRendererProps): React.ReactElement {
  return <BasicContentBlockRenderer block={block} className={className} />;
}

BasicContentBlockBRenderer.displayName = 'BasicContentBlockBRenderer';
